import React, {memo} from 'react'
import cx from 'classnames'

/* Config */
import appConfig from '../../../../appConfig'

/* Components */
import Rating from './Rating'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'
import {MODAL_IDS} from '../../../../modules/modal/modalConstants'

/* Utils */
import DataSet from '../../../../utils/DataSet'

/* Styles */
import s from './summary.scss'

const Summary = memo(({
  name,
  brandName,
  brandUrl,
  reviews,
  sku,
  listingId,
  categoryId,
  categoryUrlKeyword,
  categoryName,
  merchantId,
  merchantName,
  productId,
  price,
  categories,
  slugName,
  pageTypeForDavinci,
  position,
  energyClassBadge
}) => {
  const handleBrandClick = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.BRAND_CLICK, {
      category: {
        id: categoryId,
        name: categoryUrlKeyword,
      },
      category_hierarchy: categories.map((category) => ({id: category.categoryId, name: category.categoryName})),
      merchant: {
        id: merchantId,
        name: merchantName,
      },
      products: [
        {
          listingId,
          position: 1,
          price,
          product_id: productId,
          product_status: '',
          shipping_type: '',
          sku,
        }
      ]
    })
  }

  const handleCommentTextClick = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.COMMENT_NUMBER_CLICK, {
      category: {
        id: categoryId,
        name: categoryUrlKeyword,
      },
      category_hierarchy: categories?.map((category) => ({id: category?.categoryId, name: category?.categoryName})),
      merchant: {
        id: merchantId,
        name: merchantName,
      },
      products: [
        {
          listingId,
          position: 1,
          price,
          product_id: productId,
          product_status: '',
          shipping_type: '',
          sku,
        }
      ]
    })
  }

  const handleFirstCommentTextClick = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.FIRST_COMMENT_CLICK, {
      category: {
        id: categoryId,
        name: categoryUrlKeyword,
      },
      category_hierarchy: categories?.map((category) => ({id: category?.categoryId, name: category?.categoryName})),
      merchant: {
        id: merchantId,
        name: merchantName,
      },
      products: [
        {
          listingId,
          position: 1,
          price,
          product_id: productId,
          product_status: '',
          shipping_type: '',
          sku,
        }
      ]
    })

      if (process.env.BROWSER) {
        window.location.href = `${appConfig.baseUrl}/${slugName}-p-${sku}-yorumlari`
      }
  }

  const renderProductName = () => {
    return (
      <div className={cx(s.textArea, {[s.hasEnergyClass]: energyClassBadge?.iconUrl})} data-test-id={'title-area'}>
        <h1 className={s.name} data-test-id={'title'}>
          <a
            href={`/${brandUrl}`} title={brandName} className={s.brandName} data-test-id={'brand'}
            onClick={() => handleBrandClick()}>
            {`${brandName} `}
          </a>
          {name}
        </h1>
      </div>
    )
  }

  const renderProductInfoArea = () => {
    return (
      <div
        className={s.productInfoArea}
        data-hbus={DataSet.createComponentViewDataForDavinci({
          pageType: pageTypeForDavinci,
          pageValue: sku,
          placement: reviews?.customerReviewCount > 0 ? 'All Reviews Text' : 'First Review Text',
          component: reviews?.customerReviewCount > 0 ? 'All Reviews Text' : 'First Review Text',
          componentDetail: `Photo Icon ${reviews?.hasMedia}`,
          categoryHierarchy: `${categoryId} - ${categoryName}`,
          position,
          productId,
          merchantName,
          merchantId,
          listingId,
          price: `${price}`
        })}>
        {
          reviews?.customerReviewCount > 0 ?
            <div className={s.review} data-test-id={'has-review'}>
              <div className={s.reviewRating}>
                <span className={s.reviewScore}>{reviews?.customerReviewScore.toFixed(1).replace('.', ',')}</span>
                <Rating rate={reviews?.customerReviewScore}/>
              </div>
              <a
                className={s.reviewCount}
                href={`${appConfig.baseUrl}/${slugName}-p-${sku}-yorumlari`}
                onClick={handleCommentTextClick}
                title={`${name} Yorumları`}
                aria-label={`${reviews.customerReviewCount} Değerlendirme`}>
                <b>{reviews.customerReviewCount}</b> {'Değerlendirme'}
              </a>
              {
                reviews?.hasMedia &&
                <i className={s.cameraIcon} data-test-id={'camera-icon'}/>
              }
            </div> :
            <div className={s.noReview} data-test-id={'no-review'}>
              <i className={s.starIcon} data-test-id={'star-icon'}/>
              <span className={s.noReviewText} data-test-id={'no-review-text'}>{'Henüz değerlendirilmemiş'}</span>
              <span
                className={s.firstReview} 
                data-test-id={'first-review'} 
                onClick={handleFirstCommentTextClick}>{'İlk sen değerlendir'}
              </span>
              <i className={s.commentIcon} data-test-id={'comment-icon'}/>
            </div>
        }
      </div>
    )
  }

  return (
    <div className={s.root}>
      {renderProductName()}
      {renderProductInfoArea()}
    </div>
  )
})

export default Summary
